import React from "react";
import classNames from "classnames";
import styles from "./SquareIndicator.module.scss";

export const SquareIndicator = ({state}) => {
    return (
        <div className={classNames(styles['indicator'], styles[state])}/>
    );
};
